import React from 'react'
import {Localizer} from '../../../infrastructure/localization/localizer';
import {FravaerskodeEnum, GetFravaerskodeTranslation} from "../../sharedmodels/forloeb/fravaerskoderEnum";
import InfoBadgePill from "../../components/badge/infoBadgePill";
import {EmblaIcons} from "../../emblaIcons";
import Tooltip from "../../components/tooltips/Tooltip";
import {BadgeTypes} from "../../components/badge/badgeConstants";

interface ForloebCardBadgesProps {
    startDate: Date,
    endDate: Date,
    evalueretDato?: Date,
    godkendtDato?: Date,
    manueltAfsluttet: boolean,
    irrelevant: boolean,
    fravaer: boolean,
    forloebSkalEvalueres: boolean,
    fravaerskodeEnum?: FravaerskodeEnum,
}

export function ForloebCardBadges({
                                      startDate,
                                      endDate,
                                      evalueretDato,
                                      manueltAfsluttet,
                                      godkendtDato,
                                      irrelevant,
                                      fravaer,
                                      fravaerskodeEnum,
                                      forloebSkalEvalueres
                                  }: ForloebCardBadgesProps) {

    const todayDate = new Date().getWithoutTime();
    const forloebEndsWithin30Days = endDate < todayDate.addDays(30);

    return (
        <div className='flex-align-c'>
            <div className={"forloeb-badges"}>
                {fravaer
                    ?   <InfoBadgePill
                            badgeType={BadgeTypes.Default}
                            badgeText={GetFravaerskodeTranslation(fravaerskodeEnum)}
                        />
                    :
                    <div>
                        {startDate > todayDate &&
                            <InfoBadgePill badgeType={BadgeTypes.Default}
                                           badgeText={Localizer.global_fremtidigtForloeb()}/>
                        }
                        {endDate < todayDate &&
                            <InfoBadgePill badgeType={BadgeTypes.Default}
                                           badgeText={Localizer.global_pastForloeb()}/>
                        }
                        {manueltAfsluttet &&
                            <InfoBadgePill badgeType={BadgeTypes.Warning}
                                           badgeText={Localizer.global_manueltAfsluttet()}/>
                        }
                        {(godkendtDato !== null && godkendtDato !== undefined && !irrelevant) &&
                            <InfoBadgePill badgeType={BadgeTypes.PrimaryLight}
                                           badgeText={`${Localizer.global_tidGodkendt()} ${godkendtDato?.dateWithoutTimeFormat(true)}`}
                                           emblaIconName={EmblaIcons.Success}/>
                        }
                        {(!godkendtDato && forloebEndsWithin30Days && !irrelevant) &&
                            <InfoBadgePill badgeType={BadgeTypes.Danger} badgeText={Localizer.global_ikkeGodkendt()}
                                           additionalClasses={"color-ikkegodkendt-ikkeevalueret"}/>
                        }
                        {evalueretDato && !irrelevant &&
                            <InfoBadgePill badgeType={BadgeTypes.PrimaryLight} badgeText={Localizer.global_evalueret()}
                                           emblaIconName={EmblaIcons.Success}/>
                        }
                        {(!evalueretDato && forloebEndsWithin30Days && forloebSkalEvalueres && !irrelevant) &&
                            <InfoBadgePill badgeType={BadgeTypes.Danger} badgeText={Localizer.global_ikkeEvalueret()}
                                           additionalClasses={"color-ikkegodkendt-ikkeevalueret"}/>
                        }
                        {irrelevant &&
                            <Tooltip title={Localizer.forloebpage_notRelevantDescription()}>
                                <InfoBadgePill badgeType={BadgeTypes.Danger}
                                               badgeText={Localizer.forloebpage_ikkeRelevant()}/>
                            </Tooltip>
                        }
                    </div>
                }

            </div>
        </div>
    )
}
